<template>
  <div>
    <v-avatar size="100px"><img v-if="url" alt="Avatar" :src="url"></v-avatar>

    <v-file-input v-model="files" @change="fileupload"></v-file-input>
    {{url}}

  </div>
</template>
<script>
import axios from 'axios'

export default {
  components: {
  },
  data () {
    return {
      files: null,
      url: ''
    }
  },
  beforeCreate () {
    if (!this.$session.exists()) {
      this.$router.push('/Core/Login')
    }
  },
  methods: {
    async fileupload () {
      const _this = this
      let params = new FormData()
      params.append('file', this.files)

      axios.post(`http://0.0.0.0:5001/file/upload`, params).then(function (response) {
        _this.url = response.data
      })
    }
  }
}
</script>
<style scope>
</style>



// WEBPACK FOOTER //
// src/components/System/FileUpload.vue